import type { Moment } from 'moment';
import moment from 'moment';
import { observable } from 'mobx';

export type AnaBookingInventoryItemResponseArgs = {
  ana_booking_inventory_pair_id: number;
  ana_booking_inventory_pair_ai_operator_reservation_id: number | null;
  ana_booking_inventory_pair_ana_reservation_id: number | null;
  ana_booking_inventory_pair_is_inventoried: string | null;
  ana_booking_inventory_pair_inventoried_by: string | null;
  ana_booking_inventory_pair_inventoried_at: string | null;
  ai_operator_reservation_id: number | null;
  ai_operator_reservation_created_at: string | null;
  ai_operator_reservation_status: string | null;
  ai_operator_reservation_is_auto_processed: boolean | null;
  ana_reservation_id: number | null;
  ana_reservation_created_at: string | null;
  reservation_number: string | null;
  target_date: string | null;
  flight_name: string | null;
  price: number | null;
  reservation_date: string | null;
  ai_operator_is_inventoried: string | null;
  ai_operator_inventoried_by: string | null;
  ai_operator_inventoried_at: string | null;
  ai_operator_trip_id: number | null;
  ai_operator_trace_id: number | null;
  ai_operator_order_item_id: number | null;
  ana_is_inventoried: string | null;
  ana_inventoried_by: string | null;
  ana_inventoried_at: string | null;
  ana_trip_id: number | null;
  ana_trace_id: number | null;
  ana_order_item_id: number | null;
  last_log_message: string | null;
  last_log_message_arranger: string | null;
};

export type AnaBookingInventoryItemArgs = {
  anaBookingInventoryPairId: number;
  anaBookingInventoryPairAiOperatorReservationId: number | null;
  anaBookingInventoryPairAnaReservationId: number | null;
  anaBookingInventoryPairIsInventoried: string | null;
  anaBookingInventoryPairInventoriedBy: string | null;
  anaBookingInventoryPairInventoriedAt: Moment | null;
  aiOperatorReservationId: number | null;
  aiOperatorReservationCreatedAt: Moment | null;
  aiOperatorReservationStatus: string | null;
  aiOperatorReservationIsAutoProcessed: boolean | null;
  anaReservationId: number | null;
  anaReservationCreatedAt: Moment | null;
  reservationNumber: string | null;
  targetDate: Moment | null;
  flightName: string | null;
  price: number | null;
  reservationDate: Moment | null;
  aiOperatorIsInventoried: string | null;
  aiOperatorInventoriedBy: string | null;
  aiOperatorInventoriedAt: Moment | null;
  aiOperatorTripId: number | null;
  aiOperatorTraceId: number | null;
  aiOperatorOrderItemId: number | null;
  anaIsInventoried: string | null;
  anaInventoriedBy: string | null;
  anaInventoriedAt: Moment | null;
  anaTripId: number | null;
  anaTraceId: number | null;
  anaOrderItemId: number | null;
  lastLogMessage: string | null;
  lastLogMessageArranger: string | null;
};

export const convertAnaBookingInventoryItemResponseToArgs = (
  response: AnaBookingInventoryItemResponseArgs
): AnaBookingInventoryItemArgs => {
  const args: AnaBookingInventoryItemArgs = {
    anaBookingInventoryPairId: response.ana_booking_inventory_pair_id,
    anaBookingInventoryPairAiOperatorReservationId: response.ana_booking_inventory_pair_ai_operator_reservation_id,
    anaBookingInventoryPairAnaReservationId: response.ana_booking_inventory_pair_ana_reservation_id,
    anaBookingInventoryPairIsInventoried: response.ana_booking_inventory_pair_is_inventoried,
    anaBookingInventoryPairInventoriedBy: response.ana_booking_inventory_pair_inventoried_by,
    anaBookingInventoryPairInventoriedAt: response.ana_booking_inventory_pair_inventoried_at
      ? moment(response.ana_booking_inventory_pair_inventoried_at)
      : null,
    aiOperatorReservationId: response.ai_operator_reservation_id,
    aiOperatorReservationCreatedAt: response.ai_operator_reservation_created_at
      ? moment(response.ai_operator_reservation_created_at)
      : null,
    aiOperatorReservationStatus: response.ai_operator_reservation_status,
    aiOperatorReservationIsAutoProcessed: response.ai_operator_reservation_is_auto_processed,
    anaReservationId: response.ana_reservation_id,
    anaReservationCreatedAt: response.ana_reservation_created_at
      ? moment(response.ana_reservation_created_at)
      : null,
    reservationNumber: response.reservation_number,
    targetDate: response.target_date ? moment(response.target_date) : null,
    flightName: response.flight_name,
    price: response.price,
    reservationDate: response.reservation_date ? moment(response.reservation_date) : null,
    aiOperatorIsInventoried: response.ai_operator_is_inventoried,
    aiOperatorInventoriedBy: response.ai_operator_inventoried_by,
    aiOperatorInventoriedAt: response.ai_operator_inventoried_at
      ? moment(response.ai_operator_inventoried_at)
      : null,
    aiOperatorTripId: response.ai_operator_trip_id,
    aiOperatorTraceId: response.ai_operator_trace_id,
    aiOperatorOrderItemId: response.ai_operator_order_item_id,
    anaIsInventoried: response.ana_is_inventoried,
    anaInventoriedBy: response.ana_inventoried_by,
    anaInventoriedAt: response.ana_inventoried_at ? moment(response.ana_inventoried_at) : null,
    anaTripId: response.ana_trip_id,
    anaTraceId: response.ana_trace_id,
    anaOrderItemId: response.ana_order_item_id,
    lastLogMessage: response.last_log_message,
    lastLogMessageArranger: response.last_log_message_arranger
  };
  return args;
};

export default class AnaBookingInventoryItem {
  @observable anaBookingInventoryPairId: number;
  @observable anaBookingInventoryPairAiOperatorReservationId: number | null;
  @observable anaBookingInventoryPairAnaReservationId: number | null;
  @observable anaBookingInventoryPairIsInventoried: string | null;
  @observable anaBookingInventoryPairInventoriedBy: string | null;
  @observable anaBookingInventoryPairInventoriedAt: Moment | null;
  @observable aiOperatorReservationId: number | null;
  @observable aiOperatorReservationCreatedAt: Moment | null;
  @observable aiOperatorReservationStatus: string | null;
  @observable aiOperatorReservationIsAutoProcessed: boolean | null;
  @observable anaReservationId: number | null;
  @observable anaReservationCreatedAt: Moment | null;
  @observable reservationNumber: string | null;
  @observable targetDate: Moment | null;
  @observable flightName: string | null;
  @observable price: number | null;
  @observable reservationDate: Moment | null;
  @observable aiOperatorIsInventoried: string | null;
  @observable aiOperatorInventoriedBy: string | null;
  @observable aiOperatorInventoriedAt: Moment | null;
  @observable aiOperatorTripId: number | null;
  @observable aiOperatorTraceId: number | null;
  @observable aiOperatorOrderItemId: number | null;
  @observable anaIsInventoried: string | null;
  @observable anaInventoriedBy: string | null;
  @observable anaInventoriedAt: Moment | null;
  @observable anaTripId: number | null;
  @observable anaTraceId: number | null;
  @observable anaOrderItemId: number | null;
  @observable lastLogMessage: string | null;
  @observable lastLogMessageArranger: string | null;

  constructor(args: AnaBookingInventoryItemArgs) {
    this.anaBookingInventoryPairId = args.anaBookingInventoryPairId;
    this.anaBookingInventoryPairAiOperatorReservationId = args.anaBookingInventoryPairAiOperatorReservationId;
    this.anaBookingInventoryPairAnaReservationId = args.anaBookingInventoryPairAnaReservationId;
    this.anaBookingInventoryPairIsInventoried = args.anaBookingInventoryPairIsInventoried;
    this.anaBookingInventoryPairInventoriedBy = args.anaBookingInventoryPairInventoriedBy;
    this.anaBookingInventoryPairInventoriedAt = args.anaBookingInventoryPairInventoriedAt
      ? moment(args.anaBookingInventoryPairInventoriedAt)
      : null;
    this.aiOperatorReservationId = args.aiOperatorReservationId;
    this.aiOperatorReservationCreatedAt = moment(args.aiOperatorReservationCreatedAt);
    this.aiOperatorReservationStatus = args.aiOperatorReservationStatus;
    this.aiOperatorReservationIsAutoProcessed = args.aiOperatorReservationIsAutoProcessed;
    this.anaReservationId = args.anaReservationId;
    this.anaReservationCreatedAt = moment(args.anaReservationCreatedAt);
    this.reservationNumber = args.reservationNumber;
    this.targetDate = moment(args.targetDate);
    this.flightName = args.flightName;
    this.price = args.price;
    this.reservationDate = moment(args.reservationDate);
    this.aiOperatorIsInventoried = args.aiOperatorIsInventoried;
    this.aiOperatorInventoriedBy = args.aiOperatorInventoriedBy;
    this.aiOperatorInventoriedAt = args.aiOperatorInventoriedAt ? moment(args.aiOperatorInventoriedAt) : null;
    this.aiOperatorTripId = args.aiOperatorTripId;
    this.aiOperatorTraceId = args.aiOperatorTraceId;
    this.aiOperatorOrderItemId = args.aiOperatorOrderItemId;
    this.anaIsInventoried = args.anaIsInventoried;
    this.anaInventoriedBy = args.anaInventoriedBy;
    this.anaInventoriedAt = args.anaInventoriedAt ? moment(args.anaInventoriedAt) : null;
    this.anaTripId = args.anaTripId;
    this.anaTraceId = args.anaTraceId;
    this.anaOrderItemId = args.anaOrderItemId;
    this.lastLogMessage = args.lastLogMessage;
    this.lastLogMessageArranger = args.lastLogMessageArranger;
  }
}
